module.exports = __webpack_public_path__ + "img/30.ff360b59.jpg";